import React ,{useState,useEffect}  from 'react'
import { Card, Row, Container, CardHeader, Col, CardBody, CardTitle, NavItem, TabContent, NavLink, Nav, CardText, Button,    Table,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,TabPane, ListGroup, ListGroupItem } from 'reactstrap'
  import { Link, useNavigate, useParams } from "react-router-dom";
  import tutorsModal from 'models/tutors.modal';


const DemoAllocated = ({setDemoIndication}) => {
  const params = useParams()
  const [ClassData, setClassData] = useState({});
  
  const [isLoading, setIsLoading] = useState(false);
  const getTutorsClassData = async (id) => {
    setIsLoading(true);
    
    // Dummy data to replace API call
    const dummyData = [
      {
        _id: "1",
        tutor: "John Doe",
        parent: "Mr. Smith",
        location: "Sector 15, Noida",
        state: "Uttar Pradesh",
        city: "Noida",
        name: "Mathematics Class 10",
        Created_ON: "2024-01-15",
        start_time: "10:00 AM",
        end_time: "11:00 AM",
        status: "Completed",
        badge: "Gold",
        days: "Mon, Wed, Fri",
        duration: "1 hour",
        hours: "3",
        mode: "Online",
        number_of_session: "12",
        price_parent: "₹2000",
        price_tutor: "₹1500",
        session_per_month: "12",
        type: "Regular"
      },
      {
        _id: "2",
        tutor: "Jane Smith",
        parent: "Mrs. Sharma",
        location: "Connaught Place, Delhi",
        state: "Delhi",
        city: "New Delhi",
        name: "Physics Class 12",
        Created_ON: "2024-01-20",
        start_time: "2:00 PM",
        end_time: "3:30 PM",
        status: "Ongoing",
        badge: "Silver",
        days: "Tue, Thu, Sat",
        duration: "1.5 hours",
        hours: "4.5",
        mode: "Offline",
        number_of_session: "16",
        price_parent: "₹3000",
        price_tutor: "₹2200",
        session_per_month: "16",
        type: "Intensive"
      },
      {
        _id: "3",
        tutor: "Mike Johnson",
        parent: "Mr. Gupta",
        location: "Bandra West, Mumbai",
        state: "Maharashtra",
        city: "Mumbai",
        name: "Chemistry Class 11",
        Created_ON: "2024-01-25",
        start_time: "4:00 PM",
        end_time: "5:00 PM",
        status: "Scheduled",
        badge: "Bronze",
        days: "Daily",
        duration: "1 hour",
        hours: "7",
        mode: "Hybrid",
        number_of_session: "20",
        price_parent: "₹2500",
        price_tutor: "₹1800",
        session_per_month: "20",
        type: "Regular"
      }
    ];
    
    setTimeout(() => {
      setClassData(dummyData);
      if(dummyData.length > 0){
        setDemoIndication(true);
      } else {
        setDemoIndication(false);
      }
      setIsLoading(false);
    }, 1000);
  };
  useEffect(() => {
    getTutorsClassData();
  }, []);

  console.log(ClassData,"ClassData")
  return (
    <div>
          <div style={{ overflowX: 'auto' }}>
                      <Table  hover>
                        <thead>
                          <tr style={{ background: "#F6F9FC" }}>
                            <th id="tableheding">S.NO</th>
                            <th id="tableheding">Tutors Name</th>
                            <th id="tableheding">Parent's Name</th>
                            <th id="tableheding">Location</th>
                            <th id="tableheding">State</th>
                            <th id="tableheding">City</th>
                            <th id="tableheding">Class Name</th>
                            <th id="tableheding">Demo Date</th>
                            <th id="tableheding">Start Time</th>
                            <th id="tableheding">End Time</th>
                            <th>Status</th>
                            <th>Badge</th>
                            <th>Days</th>
                            <th>Duration</th>
                            <th>hours</th>
                            <th>mode</th>
                            <th>Number of session</th>
                            <th>Price Parent</th>
                            <th>Price Tutor</th>
                            <th>Session Per Month</th>
                            <th>type</th>
                            {/* <th>Number of session</th>
                            <th>Price Parent</th> */}
                            
                            {/* <th>Board Name</th>
                            <th>Subject Name</th> */}
                            {/* <th>Action</th> */}
                          </tr>
                        </thead>
                        {!isLoading && (
                  <tbody>
                    {ClassData.length > 0 ? (
                    
                    ClassData?.slice()
                    .reverse().map((item, index) => {
                      // let currentDate = new Date(item.createdAt);
                      // let formattedDate = currentDate
                      //   .toISOString()
                      //   .substring(0, 10);
                      return (
                        <tr key={item._id}>
                          <td>{index + 1}</td>
                          <td>{item.tutor || '-'}</td>
                          <td>{item.parent || '-'}</td>
                          <td>{item.location || '-'}</td>
                          <td>{item.state || '-'}</td>
                          <td>{item.city || '-'}</td>
                          <td>{item.name || '-'}</td>
                          <td>{item.Created_ON || '-'}</td>
                          <td>{item.start_time || '-'}</td>
                          <td>{item.end_time || '-'}</td>
                          <td>{item.status || '-'}</td>
                          <td>{item.badge || '-'}</td>
                          <td>{item.days || '-'}</td>
                          <td>{item.duration || '-'}</td>
                          <td>{item.hours || '-'}</td>
                          <td>{item.mode || '-'}</td>
                          <td>{item.number_of_session || '-'}</td>
                          <td>{item.price_parent || '-'}</td>
                          <td>{item.price_tutor || '-'}</td>
                          <td>{item.session_per_month || '-'}</td>
                          <td>{item.type || '-'}</td>
                        </tr>
                      );
                    })) : 
                    
                    <tr style={{ textAlign: "center" }}>
                    <td colSpan="6" style={{ verticalAlign: "middle" }}>
                      No data found
                    </td>
                  </tr>}
                  </tbody>
                )}

                      </Table>
                    </div>
                    <br />
              
    </div>
  )
}

export default DemoAllocated
